// @ts-nocheck
import { ProductAddToListLinkStyles } from "@insite/content-library/Components/ProductAddToListLink";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { AddToCartOptionsAndButtonStyles } from "@store/Components/Toolkit/AddToCartOptionsAndButton";
import PlusCircleFill from "@store/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import { TypographyPresentationProps } from "@store/MobiusOverrides/Typography/Typography";
import { ProductAttributesStyles } from "@store/Overrides/Components/ProductAttributes";
import { ProductAvailabilityStyles } from "@store/Overrides/Components/ProductAvailability";
import { ProductBrandStyles } from "@store/Overrides/Components/ProductBrand";
import { ProductDescriptionStyles } from "@store/Overrides/Components/ProductDescription";
import { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import { ProductImageBadgesStyles } from "@store/Overrides/Components/ProductImageBadges";
import { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
import { ProductQuantityBreakPricingStyles } from "@store/Overrides/Components/ProductQuantityBreakPricing";
import { ProductTextBadgesStyles } from "@store/Overrides/Components/ProductTextBadges";
import { typographyProductNameStyles } from "@store/Themes/common/mixins/typography";
import { attributeSpacing } from "@store/Themes/common/props/attributes";
import { badgeProps } from "@store/Themes/common/props/badge";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@store/Themes/common/mixins/spacing";
import { css } from "styled-components";

/* Store Custom Code - Start */
import HeartPlus from "@store/Components/Toolkit/Icons/Heart/HeartPlus";
/* Store Custom Code - End */

export interface ProductCardProps {
    card?: InjectableCss;
    spacingWrapper?: InjectableCss;
    brand?: ProductBrandStyles;
    description?: ProductDescriptionStyles;
    image?: ProductImageStyles;
    sponsoredText?: TypographyPresentationProps;
    partNumbers?: ProductPartNumbersStyles;
    attributes?: ProductAttributesStyles;
    availability?: ProductAvailabilityStyles;
    badgeAreaWrapper?: InjectableCss;
    badgeTextWrapper?: InjectableCss;
    badgeText?: TypographyPresentationProps;
    badgeImageWrapper?: InjectableCss;
    textBadges?: ProductTextBadgesStyles;
    imageBadges?: ProductImageBadgesStyles;
    actionsWrapper?: InjectableCss;
    price?: ProductPriceStyles;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    addToCartOptionsAndButton?: AddToCartOptionsAndButtonStyles;
    addToListWrapper?: InjectableCss;
    addToListLink?: ProductAddToListLinkStyles;
}

const spacingWrapper: InjectableCss = {
    css: css`
        ${x => spacingStyles(0, x.theme.design.product.list.contentSpacing)}
    `,
};

const labelProps: TypographyPresentationProps = {
    variant: "legend",
    css: css`
        ${x => x.theme.typography.legend.css}
    `,
};

export const productCardProps: ProductCardProps = {
    spacingWrapper,
    card: {
        css: css`
            position: relative;
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            background-color: ${getColor("common.background")};
            padding: ${pxToRem(20)};
            /* Store Removed - border */
            /* Store Removed - border-radius */
            /* Store Custom Code - Start */
            box-shadow:
                0 2px 2px 0 #00000017,
                0 0 1px 0 #00000073;
            /* Store Custom Code - End */
        `,
    },
    image: {
        wrapper: {
            css: spacingStyles(null, pxToRem(14)),
        },
        linkWrappingImage: {
            css: css`
                max-height: ${pxToRem(180)};
            `,
        },
    },
    sponsoredText: {
        css: css`
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            font-size: ${x => x.theme.design.typography.size.tiny};
            padding: 0.5em 1em;
            border: ${pxToRem(1)} solid ${getColor("common.border")};
            border-top: 0;
            background: ${getColor("common.background")};
            color: ${getColor("text.accent")};
        `,
    },
    brand: {
        /* Store Custom Code - Start */
        wrapper: {
            css: spacingStyles(null, pxToRem(3)),
        },
        nameLink: {
            typographyProps: {
                css: css`
                    text-transform: capitalize;
                    font-weight: ${x => x.theme.design.typography.weight.base};
                    font-size: ${x => x.theme.design.typography.size.tiny};
                `,
            },
        },
        /* Store Custom Code - End */
    },
    description: {
        wrapper: {
            ...spacingWrapper,
            forwardAs: "h3",
            css: css`
                ${spacingWrapper.css}
                ${typographyProductNameStyles()}
            `,
        },
    },
    partNumbers: {
        wrapper: {
            css: spacingStyles(null, attributeSpacing),
        },
        /* Store Custom Code - Start */
        erpNumberLabelText: {
            css: css`
                ${({ theme }) => css`
                    font-size: ${theme.design.typography.size.smaller};
                    font-weight: ${theme.design.typography.weight.medium};
                `}
            `,
        },
        erpNumberValueText: {
            css: css`
                ${({ theme }) => css`
                    font-size: ${theme.design.typography.size.smaller};
                    font-weight: ${theme.design.typography.weight.medium};
                `}
            `,
        },
        /* Store Custom Code - End */
    },
    attributes: {
        container: {
            css: spacingStyles(null, attributeSpacing),
        },
    },
    availability: {
        wrapper: spacingWrapper,
        inventoryMessage: {
            css: css`
                margin: ${pxToRem(4, 0)};
            `,
        },
    },
    badgeAreaWrapper: badgeProps.badgeAreaWrapper,
    badgeTextWrapper: badgeProps.badgeTextWrapper,
    badgeText: badgeProps.badgeText,
    badgeImageWrapper: badgeProps.badgeImageWrapper,
    textBadges: {
        tagWrapper: {
            extendedStyles: {
                wrapper: {
                    css: css`
                        ${spacingWrapper.css}
                        padding: ${pxToRem(4, 0)};
                    `,
                },
            },
        },
    },
    imageBadges: {
        flexWrapper: {
            extendedStyles: {
                wrapper: {
                    css: css`
                        ${spacingWrapper.css}
                        width: 100%;
                    `,
                },
            },
        },
    },
    actionsWrapper: {
        css: css`
            ${spacingWrapper.css}
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            flex-grow: 1;
        `,
    },
    price: {
        wrapper: {
            css: css`
                padding: ${pxToRem(2, 0)};
            `,
        },
    },
    quantityBreakPricing: {},
    addToCartOptionsAndButton: {
        flexWrapper: {
            extendedStyles: {
                wrapper: spacingWrapper,
                /* Store Custom Code - Start */
                content: {
                    css: css`
                        justify-content: space-between;
                    `,
                },
                /* Store Custom Code - End */
            },
        },
        unitOfMeasure: {
            extendedStyles: {
                labelProps,
            },
        },
        quantityOrdered: {
            extendedStyles: {
                labelProps,
            },
        },
    },
    addToListWrapper: {
        css: css`
            ${spacingWrapper?.css}
            display: flex;
        `,
    },
    addToListLink: {
        link: linkGetActionLinkProps(HeartPlus) /* Store Custom Code */,
    },
};
